export const customPortfolio = {
  zh: {
    cumulativeReturn: "累計報酬",
    yearlyReturn: "年報酬",
    portfolioReturn: "投資組合報酬",
    benchmarkReturn: "標普500報酬",
  },
  en: {
    cumulativeReturn: "Cumulative Return",
    yearlyReturn: "Yearly Return",
    portfolioReturn: "Portfolio Return",
    benchmarkReturn: "S&P500 Returns",
  },
};
